<div [formGroup]="form" fxLayout="column">
  <mat-panel-title> HORÁRIO DE FUNCIONAMENTO </mat-panel-title>

  <div fxLayout="column">
    <div
      *ngFor="let day of daysOfWeek"
      fxLayout="row"
      fxLayoutGap="4"
      fxLayoutAlign="start center"
      style="border-top: 0.5px solid #aaa; padding-top: 15px"
    >
      <div fxFlex="30">
        <app-slide-toggle
          [config]="getFieldConfig('check' + day + 'BusinessHour')"
          [group]="form"
          [typeCes]="typeCes"
        ></app-slide-toggle>
      </div>
      <div fxFlex="70">
        <div fxLayout="row" fxLayoutGap="8">
          <div fxFlex="35">
            <app-input-time
              [config]="getFieldConfig('start' + day + 'BusinessHour')"
              [group]="form"
              [typeCes]="typeCes"
            ></app-input-time>
          </div>
          <div fxFlex="35">
            <app-input-time
              [config]="getFieldConfig('end' + day + 'BusinessHour')"
              [group]="form"
              [typeCes]="typeCes"
            ></app-input-time>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div fxFlex="initial" fxLayoutAlign="end" fxLayoutGap="8">
    <button
      class="custom-button"
      type="button"
      mat-raised-button
      (click)="close()"
    >
      SAIR
    </button>
    <button
      class="custom-button btn-save"
      type="button"
      variant="contained"
      mat-raised-button
      (click)="ok()"
    >
      OK
    </button>
  </div>
</div>
